import { useEffect, useState } from 'react';
import { handleMsgOnPayField } from '../../utils';
import { PayFieldView } from './PayFieldView';
import { useInitPayField } from '../../hooks/useInitApp';
import { useSearchParams } from 'react-router-dom';

export const PayFieldContainer = () => {
  const [search] = useSearchParams();
  const session = search.get('session') ?? '';
  const payPage = search.get('paypage') ?? '';
  const clientId = search.get('clientId') ?? '';
  const libInitializeId = search.get('libInitializeId') ?? '';

  const [libVersion, setLibVersion] = useState('');

  const { isInit, ...params } = useInitPayField({ session, payPage, clientId, libVersion });

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      handleMsgOnPayField({ event, setLibVersion, sessionId: session, libInitializeId });
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return isInit ? <PayFieldView { ...params } /> : <></>;
};
